<template>
	<div class="accordion" id="fixed-income-sales-available">
		<div class="card shadow-sm mg-b-40">
			<div class="card-header pd-t-20 d-sm-flex align-items-start justify-content-between bd-b-0 pd-b-0">
				<div>
					<h6 class="mg-b-5">
						<button class="btn btn-link" type="button" data-toggle="collapse" data-target="#collapseFixedIncomeAvailable" aria-expanded="true" aria-controls="collapseFixedIncomeAvailable">
							Fixed Income Securites Available
						</button>
					</h6>
					<p class="tx-13 tx-color-03 mg-b-0"></p>
				</div>
			</div>
			<div id="collapseFixedIncomeAvailable" class="collapse show" data-parent="#fixed-income-sales-available">
				<div class="card-body fixed-income-sales-available pd-y-30">
					<div class="table-responsive">
						<table class="table table-dashboard mg-b-0" aria-describedby="fixed-income-sales-available-table">
							<thead>
								<tr>
									<th scope="col">ISIN</th>
									<th scope="col">Description</th>
									<th scope="col">Yield</th>
									<th scope="col">Maturity</th>
									<th scope="col" class="tx-medium text-center">Price</th>
									<th scope="col" class="tx-medium text-center">Coupon</th>
									<th scope="col" class="tx-medium text-center">Your holdings</th>
									<th scope="col" class="tx-medium text-center">Trade Options</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(fixedIncome, index) in fixedIncomeAvailable" :key="index">
									<td class="tx-color-03 tx-medium">{{ fixedIncome.security_isin }}</td>
									<td class="tx-color-03 tx-medium">{{ fixedIncome.security_details.description }}</td>
									<td class="tx-color-03 tx-medium">{{ fixedIncome.yield | placeholder }}</td>
									<td class="tx-color-03 tx-medium">{{ fixedIncome.security_details.maturity_date | toDate('dddd, Do MMMM YYYY') | placeholder }}</td>
									<td class="tx-medium text-center">{{ fixedIncome.security_details.price.value | toNumber }}</td>
									<td class="tx-medium text-center">{{ fixedIncome.coupon | toPercentage | placeholder }}</td>
									<td class="tx-medium text-center">{{ fixedIncome.holding ? fixedIncome.holding.units : '' | toNumber | placeholder }}</td>

									<td class="tx-medium">
										<button type="button" class="btn btn-sm btn-primary shadow-sm" :disabled="fixedIncome.selected" @click="selectFixedIncome(fixedIncome.security_isin)">
											Trade
										</button>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { trade } from '../../../../../mixins';

export default {
	mixins: [trade],
	methods: {
		selectFixedIncome(isin) {
			this.$emit('select-fixed-income', isin);
		},
	},
	props: {
		fixedIncomeAvailable: {
			type: Array,
			required: true,
		},
	},
};
</script>

<style>
</style>